'use es6';

import PropTypes from 'prop-types';
import MenuNodeItemPreview from 'simple-menus-lib/components/dnd/preview/MeunNodeItemPreview';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MenuNodePreview = props => {
  const {
    id,
    parentId,
    children,
    getMenuComponent,
    depth,
    menuId
  } = props;
  const MenuComponent = getMenuComponent(true);
  return /*#__PURE__*/_jsxs("div", {
    className: "simple-menus-menu-node",
    children: [/*#__PURE__*/_jsx(MenuNodeItemPreview, {
      id: id,
      parentId: parentId,
      depth: depth,
      menuId: menuId
    }), /*#__PURE__*/_jsx(MenuComponent, {
      className: "m-top-4",
      parentId: id,
      nodes: children,
      getMenuComponent: getMenuComponent,
      depth: depth + 1,
      menuId: menuId
    })]
  });
};
MenuNodePreview.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  menuId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  children: PropTypes.arrayOf(PropTypes.any).isRequired,
  getMenuComponent: PropTypes.func.isRequired,
  depth: PropTypes.number.isRequired
};
MenuNodePreview.defaultProps = {
  children: []
};
export default MenuNodePreview;